import { Check, Close } from "@mui/icons-material";
import { styled } from "@mui/material";

const StyledBox = styled("div")({
  height: "100%",
  display: "flex",
  alignItems: "center",
});

export const BooleanCell = ({ value }: { value: never }) => {
  if (value === true) {
    return (
      <StyledBox>
        <Check fontSize="inherit" color="success" />
      </StyledBox>
    );
  }

  if (value === false) {
    return (
      <StyledBox>
        <Close fontSize="inherit" color="error" />
      </StyledBox>
    );
  }

  return <span>N/A</span>;
};
